import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { forkJoin, Subscription } from 'rxjs';
import { LifestyleService } from 'src/app/services/ha-new/lifestyle.service';
import { SpinnerComponent } from 'src/app/modules/shared/spinner/spinner.component';
import { ActivatedRoute } from '@angular/router';
import { LookupService } from 'src/app/services/ha-new/lookup.service';
import { NewHAService } from 'src/app/services/ha-new/new-ha.service';

@Component({
	selector: 'app-how-you-sleep',
	templateUrl: './how-you-sleep.component.html',
	styleUrls: ['./how-you-sleep.component.scss'],
})
export class HowYouSleepComponent implements OnInit {
	/** Data carrier subscriptions */
	subscriptions: Subscription[] = [];
	/** holds ha id */
	healthAssessmentID: number = 0;
	/** holds appointment id */
	apptID: any;
	/** holds readOnly flag */
	readOnly: boolean = false;
	howYouSleepData: any = {};
	satisfiedWithSleepValues: any = [];
	difficultyWithSleepValues: any = [];
	difficultySleeping: boolean;
	// sleepDifficultiesResponses: any=[]
	howYouSleepForm: FormGroup;
	scrollTo = '';
	max = 24;
	min = 1;
	showTicks = true;
	step = 1;
	value = 0;
	showTickMarks = true;
	showThumbLabel = false;
	returningUser: boolean = false;

	constructor(
		private lifestyleService: LifestyleService,
		private spinner: SpinnerComponent,
		private activatedRoute: ActivatedRoute,
		private lookupService: LookupService,
		private haService: NewHAService
	) {
		this.activatedRoute.queryParams.subscribe(params => {
			//console.log('params:', params);
			this.apptID = params.apptID;
			this.readOnly = params.readOnly === 'true';
			this.healthAssessmentID = params.healthAssessmentID;
			this.returningUser = params.returningUser === 'true';
			if (this.scrollTo != 'false') {
				this.scrollTo = params.section;
			}
		});
	}

	ngOnInit() {
		this.getLookup();
		this.initializeHowYouSleepForm();
	}

	next() {
		if (!this.readOnly) {
			if (this.howYouSleepForm.valid) {
				this.saveHowYouSleep();
			}
		}
	}

	getLookup() {
		this.spinner.startLoader();
		forkJoin({
			getSatisfiedWithSleepLookupValues: this.lookupService.getSatisfiedWithSleepLookupValues(),
			getDifficultyWithSleepLookupValues: this.lookupService.getDifficultyWithSleepLookupValues(),
			howYouSleep: this.lifestyleService.getHowYouSleep(this.apptID, this.healthAssessmentID),
		}).subscribe(res => {
			this.satisfiedWithSleepValues = res.getSatisfiedWithSleepLookupValues.data;
			this.satisfiedWithSleepValues.forEach(condition => {
				condition['checked'] = false;
			});
			this.difficultyWithSleepValues = res.getDifficultyWithSleepLookupValues.data;
			this.difficultyWithSleepValues.forEach(condition => {
				condition['checked'] = false;
			});
			this.getHowYouSleep(res.howYouSleep);
			this.spinner.stopLoader();
			if (this.scrollTo != 'false') {
				if (this.haService.scrollView(this.scrollTo)) {
					this.scrollTo = 'false';
				}
			}
		}),
			err => {
				console.error(`[${HowYouSleepComponent.name}][${this.getLookup.name}]`, 'error getting how you sleep data', err);
				this.spinner.stopLoader();
			};
	}

	difficultyWithSleepSelection(condition) {
		//console.log(condition);
		condition.checked = !condition.checked;
		const index = this.howYouSleepData.sleepDifficultiesResponses.findIndex(x => x.optionID == condition.id);
		if (condition.checked) {
			if (index == -1)
				this.howYouSleepData.sleepDifficultiesResponses.push({
					optionID: condition.id,
				});
		} else {
			this.howYouSleepData.sleepDifficultiesResponses.splice(index, 1);
		}
	}

	difficultySleepingRadio(event) {
		this.difficultySleeping = event.value;
	}

	getHowYouSleep(response) {
		this.howYouSleepData = response.data;
		this.howYouSleepForm.controls.hoursOfSleep.setValue(this.howYouSleepData.hoursOfSleep);
		this.howYouSleepForm.controls.satisfiedWithSleep.setValue(this.howYouSleepData.satisfiedWithSleep);
		this.howYouSleepForm.controls.difficultySleeping.setValue(this.howYouSleepData.difficultySleeping);
		this.difficultySleeping = this.howYouSleepData.difficultySleeping;
		this.howYouSleepForm.controls.feelTired.setValue(this.howYouSleepData.feelTired);
		this.howYouSleepForm.controls.sufferJetLag.setValue(this.howYouSleepData.sufferJetLag);
		this.howYouSleepForm.controls.nightShifts.setValue(this.howYouSleepData.nightShifts);
		if (!this.howYouSleepData.sleepDifficultiesResponses) {
			this.howYouSleepData.sleepDifficultiesResponses = [];
		}
		this.howYouSleepData.sleepDifficultiesResponses.forEach(element => {
			this.difficultyWithSleepValues.find(e => {
				return e.id === element.optionID;
			})['checked'] = true;
		});
	}

	/**
	 * saves safety
	 */
	saveHowYouSleep() {
		const formData = this.howYouSleepForm.getRawValue();
		// Prepopulated value if available and the value has not been updated
		if (this.returningUser || (!this.returningUser && this.selectionMade('hoursOfSleep'))) {
			// formData.hoursOfSleep = formData.hoursOfSleep;
		} else if (this.howYouSleepData.hoursOfSleep) {
			formData.hoursOfSleep = this.howYouSleepData.hoursOfSleep;
		} else {
			formData.hoursOfSleep = undefined;
		}
		this.subscriptions.push(
			this.lifestyleService
				.saveHowYouSleep(this.apptID, {
					...formData,
					healthAssessmentID: this.howYouSleepData.healthAssessmentID,
					sleepDifficultiesResponses: this.difficultySleeping ? this.howYouSleepData.sleepDifficultiesResponses : [],
				})
				.subscribe(
					res => {
						//console.log(res);
						this.haService.redirect(
							[],
							[],
							['substance-abuse'],
							this.apptID,
							this.healthAssessmentID,
							this.readOnly,
							'lifestyle-substance-abuse',
							this.returningUser
						);
					},
					err => {
						console.log(err);
					}
				)
		);
	}

	initializeHowYouSleepForm() {
		this.howYouSleepForm = new FormGroup({
			hoursOfSleep: new FormControl(''),
			satisfiedWithSleep: new FormControl(''),
			difficultySleeping: new FormControl(''),
			feelTired: new FormControl(''),
			sufferJetLag: new FormControl(''),
			nightShifts: new FormControl(''),
		});
	}

	selectionMade(slider) {
		return this.howYouSleepForm.get(slider).touched;
	}
}
